import Vue from 'vue'
import { ModalPlugin } from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'font-awesome/css/font-awesome.css'
import router from './router'
import i18n from './i18n'
import store from './store'
import { getMessagePack } from './i18n/external'
import { getBrandInfo } from '@/api/brand'
import { info } from '@/api/user'
import { toErrorPage, loadBaseCss, loadDynamicCss } from '@/utils/tool'
import { logout } from '@/utils/user'
import '@/utils/filters'
import Cookies from 'js-cookie'
import CustomSocket from '@/services/socket'
import { forceApp, showNotice, toMaintainPage, toForbiddenPage } from '@/utils/tool'
import App from './App.vue'
// 先load基本css免得破版
loadBaseCss()
// loadDynamicCss('theme1')

if (process.env.VUE_APP_ENV === 'production' && location.protocol === 'http:') {
  location.href = location.href.replace(/^http:/, 'https:')
}

Vue.config.productionTip = false

Vue.use(ModalPlugin)

Vue.filter('numberFormat', function(price) {
  if (!isNaN(price) && price !== null) {
    return parseFloat(Math.floor(price * 100) / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }
  return price
})
// 開啟socket
Vue.use(CustomSocket)

// 不能在iframe中
// if (window !== window.top) {
//   window.top.location.href = window.location.href
// }

// 需要登入的頁面判斷
router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.needLogin) {
    if (!store.getters.token) {
      logout(i18n.t('Bao.please_login_for_function'))
    }
  }
  store.commit('SET_HIDE_MOBILE_NAV', false)
  next()
})

Vue.directive('visible', function(el, binding) {
  el.style.visibility = binding.value ? 'visible' : 'hidden'
})

store.commit('SET_LOADING', true)
store.commit('SET_LOAD_COMPLETED', false)

store.commit('SET_HIDE_MOBILE_NAV', false)

let brandCode = process.env.VUE_APP_BRAND_CODE // 開發環境指定brand code
if (brandCode === '') {
  brandCode = window.location.host || document.location.host // 剛開始載入先用host取資訊
}

// 重新取相關資訊
store.commit('SET_BRAND_INFO', null)
store.commit('SET_NOTICE_MESSAGE', null)

// 偵測與系參數
let language = new URL(window.location.href || document.location.href).searchParams.get('language') || Cookies.get('language')
let brandObject = {}
if (language !== null && language !== undefined) {
  brandObject = { code: brandCode, language: language }
} else {
  brandObject = { code: brandCode }
}

// 偵測網址token
const queryToken = new URL(window.location.href || document.location.href).searchParams.get('token')
if (queryToken) {
  store.commit('SET_TOKEN', queryToken)
}

// 呈現ui
new Vue({
  router,
  i18n,
  store,
  created() {
    // API取得聽資訊
    getBrandInfo(brandObject).then((response) => {
      // 自訂js code
      if (response.data.data.brandInfo.custom_script !== '') {
        const script = document.createElement('script')
        script.setAttribute('type', 'text/javascript')
        script.setAttribute('language', 'javascript')
        const inlineScript = document.createTextNode(response.data.data.brandInfo.custom_script)
        script.appendChild(inlineScript)
        document.body.insertAdjacentElement('afterend', script)
      }

      if (forceApp(this.$router.currentRoute.name, response.data.data.permissionInfo.mobile_force_app)) {
        setTimeout(function() { window.location = response.data.data.urlInfo.appDownloadUrl }, 5000)
        showNotice(this.$t('Bao.downAppNotice'), function() {
          window.location = response.data.data.urlInfo.appDownloadUrl
        }, false)
      }

      store.commit('SET_BRAND_INFO', response.data.data)
      // 換版型
      // console.log(this.$store.getters.brand.theme)
      // if (this.$store.getters.brand.theme !== 'theme1') {
      //   loadDynamicCss(this.$store.getters.brand.theme)
      // }

      // 感恩節活動頁不要載入其他主題css避免互相干擾
      const eventPath = ['/Thanksgivingday', '/Thanksgivingday2', '/Thanksgivingday3',
        '/Xmas', '/Xmas2', '/Xmas3', '/Xmas4', '/Xmas5', '/Xmas6']
      if (!eventPath.includes(this.$route.path)) {
        loadDynamicCss(this.$store.getters.brand.theme)
      }

      // import('@/assets/' + response.data.data.theme + '/ui.css')
      document.title = response.data.data.brandInfo.site_title

      // icon
      var link = document.querySelector("link[rel*='icon']") || document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = response.data.data.brandInfo.image_square
      document.getElementsByTagName('head')[0].appendChild(link)

      // 電話代碼
      const phoneCode = response.data.data.supportPhoneCode
      store.commit('SET_SUPPORT_PHONE_CODE', phoneCode)

      // 圖片
      const brandImage = response.data.data.brandImage
      store.commit('SET_BRAND_IMAGE', brandImage)

      // 語系
      const languages = response.data.data.brandInfo.language
      if (!languages || languages.length === 0) {
        toErrorPage('Cant get language')
      } else {
        store.commit('SET_SUPPORT_LANGUAGES', languages)

        if (!languages.includes(language)) {
          language = languages[0]
        }
        store.commit('SET_LANGUAGE', language)
      }
      getMessagePack(language).then(r => {
        store.commit('SET_LOADING', false)
        store.commit('SET_LOAD_COMPLETED', true)
      })
      // 如果有token 強制更新個人資料
      if (store.getters.token) {
        info().then(response => {
          const reqData = response.data
          store.dispatch('SetUserData', reqData.data)
        })
      }
      store.dispatch('UpdateCsUrl')
    }).catch((e) => {
      const data = e.response.data.data

      if (data) {
        if (data.type === 'maintain') {
          toMaintainPage(data.content)
        } else if (data.type === 'ip_forbidden') {
          toForbiddenPage(data.content)
        }
      }

      if (e.response.status === 403) {
        toForbiddenPage(e.response.data.msg)
      }

      store.commit('SET_LOADING', false)
      // 基本參數查不到 導向錯誤頁
      store.commit('SET_LOAD_COMPLETED', true)

      store.commit('SET_ERROR_MESSAGE', data.content)
      router.push({ path: '/critical' }, () => {
      })

      // if (store.getters.errorMessage === null) {
      //   router.push({ path: '/critical' }, () => {
      //   })
      // } else {
      //   router.push({ path: '/error' }, () => {
      //   })
      // }
    })
  },
  render: h => h(App)
}).$mount('#app')
